import Button from "@builder/components/general/Button";
import OliverText, { TextType } from "@builder/components/general/OliverText";
import { useState } from "react";
import "./style.scss";
import TooltipElement from "@builder/components/general/Tooltip";
import CreateImageSettingForm from "@builder/components/app/Popup/popups/DynamicData/CheckoutFlowSettings/ImageSettings/CreateImageSettingForm";
import { useAppDispatch } from "@builder/store/store";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { closePopup } from "@builder/store/slices/popupSlice";
import { BuildSettingsKey } from "@builder/store/slices/buildSettingsKeys/buildSettingsKeySlice";
import { useTranslation } from "react-i18next";

interface ImageSettingsProps {
    settings?: Partial<BuildSettingsKey>[];
}

const ImageSettings = ({ settings }: ImageSettingsProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation()
    const [creatingNew, setCreatingNew] = useState<boolean>(false);
    const [editIndex, setEditIndex] = useState<number | null>(null);

    const handleSelectKey = (value?: string) => {
        if (value) {
            dispatch(updateNodeProperty({ propertyPath: ["dynamicData"], value }));
            dispatch(closePopup());
        }
    };

    const handleEditKey = (e: React.MouseEvent, index: number) => {
        e.stopPropagation();
        setEditIndex(index);
    };

    return (
        <div className="image-settings-wrapper">
            {settings?.length === 0 && !creatingNew && (
                <div className="empty-settings-data">
                    <img src="./no-selector.svg" />
                    <OliverText text={t("checkoutFlow.newCheckoutFlow")} type={TextType.BODY_3} />
                    <div className="button-wrapper">
                        <Button
                            buttonStyle="primary"
                            text="Create new"
                            textType={TextType.BODY_2}
                            size="small"
                            onClick={() => setCreatingNew(true)}
                        />
                    </div>
                </div>
            )}
            {settings?.length !== 0 && !creatingNew && (
                <div className="image-settings-header">
                    <div className="is-header-row">
                        <div className="is-header-group">
                            <OliverText text={t("checkoutFlow.selectData")} type={TextType.BODY_1} color="base-grey" />
                            <TooltipElement text={t("checkoutFlow.tooltip")}>
                                <img src="./circle-question.svg" alt="" />
                            </TooltipElement>
                        </div>
                        <button onClick={() => setCreatingNew(true)}>
                            <img src="./plus.svg" alt="" />
                            <OliverText text={t("checkoutFlow.addNew")} type={TextType.BODY_4} />
                        </button>
                    </div>
                    <div className="is-header-text-wrapper">
                        <OliverText text={t("checkoutFlow.prevData")} color="base-grey" type={TextType.BODY_LIGHT_XS} />
                    </div>
                </div>
            )}
            {creatingNew && <CreateImageSettingForm closeEdit={() => setCreatingNew(false)} />}
            {settings?.map((setting, index) =>
                editIndex === index ? (
                    <CreateImageSettingForm key={index} defaultValues={setting} closeEdit={() => setEditIndex(null)} />
                ) : (
                    <div className="image-settings" key={index} onClick={() => handleSelectKey(setting.key)}>
                        <div className="image-settings-col">
                            <div className="image-settings-row">
                                <img src="./final-logo.svg" alt="" />
                                <OliverText text={setting.label} type={TextType.SUBTITLE_3} />
                            </div>
                            <OliverText text={setting.description} type={TextType.BODY_4} color="base-grey" />
                            {setting.placeholder && (
                                <div className="placeholder-group">
                                    <OliverText type={TextType.BODY_4} text={t("checkoutFlow.placeholderFallback")} />
                                    <div className="placeholder-image-wrapper">
                                        <img src={setting.placeholder} alt="" />
                                    </div>
                                </div>
                            )}
                        </div>
                        <button className="edit-settings-key" onClick={e => handleEditKey(e, index)}>
                            <img src="./pencil-edit.svg" />
                        </button>
                    </div>
                )
            )}
        </div>
    );
};

export default ImageSettings;
